define(['jquery'], function($){
	$.fn.socialShare = function() {
		var urls = [];
		urls['fb'] = "https://facebook.com/sharer/sharer.php?u=${url}";
		urls['twitter'] = "https://twitter.com/intent/tweet/?text=${title}&url=${url}";
		urls['linkedin'] = "https://www.linkedin.com/sharing/share-offsite/?url=${url}";

		$(this).bind('click', function(e) {
			e.preventDefault();
			var type = $(this).data('socialNetwork');
			var pageurl = String(document.URL).replace('?back=1', '');
			var pagename = document.title;

			var title = '', url = '';

			switch (type) {
				case 'fb' :
					url = encodeURIComponent(pageurl);
					title = encodeURIComponent(pagename);
					break;
				case 'twitter':
					title = encodeURIComponent(pagename+': '+pageurl);
					break;
				case 'gplus':
					url = encodeURIComponent(pageurl);
					break;
				case 'linkedin':
					url = encodeURIComponent(pageurl);
					title = encodeURIComponent(pagename);
					break;
				default:
					break;
			}
			window.open(urls[type].replace(/\${url}/gi,url).replace(/\${title}/gi,title), 'social'+type);
		});
	};
});



// WEBPACK FOOTER //
// ./fe/web-gmeinder/src/js/web/jquery.socialshare.js